import marked from 'marked';

const convertStringToHTML = (value = '') => {
  let result = {};

  marked(value, { breaks: true }, (err, htmlContent) => {
    if (err) throw err;
    result = {
      htmlContent,
      content: value
    };
  });

  return result;
};

export default convertStringToHTML;
